// Template196: Bangkok - Chinatown (Día 3). Idéntico a PageChinatown.jsx. borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template196 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content ?? "Día 3: Contrastes urbanos";
	const intro = page?.texts?.[1]?.content;
	const titleOverlay = page?.texts?.[2]?.content ?? "Chinatown";
	const yaowaratTitle = page?.texts?.[3]?.content ?? "YAOWARAT ROAD";
	const yaowaratBody = page?.texts?.[4]?.content;
	const streetFoodTitle = page?.texts?.[5]?.content ?? "STREET FOOD";
	const streetFoodBody = page?.texts?.[6]?.content;
	const watTitle = page?.texts?.[7]?.content ?? "Wat Traimit";
	const watBody = page?.texts?.[8]?.content;
	const consejoText = page?.texts?.[9]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const streetFoodImage = getImageSrc("street-food");
	const watTraimitImage = getImageSrc("wat-traimit");
	const stickerUrl = getCanvasImageUrl("sticker");
	const watStickerUrl = getCanvasImageUrl("wat-sticker");
	const logoImage = getCanvasImageUrl("logo");
	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#000",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontSize: isSmallScreen ? 28 : 32,
							textAlign: "center",
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
				{stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{ width: 90, position: "absolute", bottom: 60, left: 18 }}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box sx={{ fontSize: "13px", color: "#333", margin: 0, padding: 0 }}>
						{intro}
					</Box>
				)}
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: 1.25,
					}}
				>
					<Box data-block-id="text-2" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{streetFoodImage && (
							<Box
								component="img"
								src={streetFoodImage}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						{sabiasQue.length > 0 && (
							<>
								<Box
									sx={{
										position: "absolute",
										top: 0,
										left: isSmallScreen ? "33%" : "35%",
									}}
								>
									<SabiasQue
										icono={sabiasQue[0]?.icono ?? "🏮"}
										texto={sabiasQue[0]?.texto ?? ""}
									/>
								</Box>
								{sabiasQue[1] && (
									<Box
										sx={{
											position: "absolute",
											top: 50,
											left: isSmallScreen ? "33%" : "35%",
										}}
									>
										<SabiasQue
											icono={sabiasQue[1]?.icono ?? "💰"}
											texto={sabiasQue[1]?.texto ?? ""}
										/>
									</Box>
								)}
							</>
						)}
						<Box sx={{ width: "60%" }}>
							<Box component="h3" sx={estiloH3}>
								{yaowaratTitle}
							</Box>
							{yaowaratBody && (
								<Box component="p" sx={estiloP}>
									{yaowaratBody}
								</Box>
							)}
						</Box>
					</Box>

					<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, position: "relative" }}>
						<Box sx={{ width: "100%" }}>
							<Box
								component="p"
								sx={{
									...estiloP,
									padding: 1.5,
									backgroundColor: "#fff3cd",
									borderRadius: "12px",
								}}
							>
								{watStickerUrl && (
									<Box
										component="img"
										src={watStickerUrl}
										alt=""
										sx={{
											width: isSmallScreen ? 105 : 115,
											float: "right",
											marginRight: -2.5,
											marginTop: -2.5,
										}}
									/>
								)}
								<Box component="h3" sx={estiloH3}>
									{streetFoodTitle}
								</Box>
								{streetFoodBody}
							</Box>
						</Box>
					</Box>

					<Box data-block-id="text-4" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{watTraimitImage && (
							<Box
								component="img"
								src={watTraimitImage}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							<Box component="h3" sx={estiloH3}>
								{watTitle}
							</Box>
							{watBody && (
								<Box component="p" sx={estiloP}>
									{watBody}
								</Box>
							)}
						</Box>
					</Box>

					{consejoText && (
						<Box
							data-block-id="text-5"
							sx={{
								backgroundColor: "#d4edda",
								border: "3px solid #28a745",
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: "13px",
								color: "#333",
								marginBottom: isSmallScreen ? 1.5 : 0,
							}}
						>
							<Box component="p" sx={{ margin: 0, ...estiloP }}>
								{consejoText}
							</Box>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template196.thumbnail = "/images/template-1.png";
export default Template196;
